module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "regular-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit()
      }
    }
  }, [_c('rate-plan-name-field', {
    attrs: {
      "error": _vm.$attrs.errors.rate_plan.name
    },
    model: {
      value: (_vm.$attrs['rate-plan'].name),
      callback: function($$v) {
        _vm.$set(_vm.$attrs['rate-plan'], "name", $$v)
      },
      expression: "$attrs['rate-plan'].name"
    }
  }), _vm._v(" "), _c('amount-field', {
    attrs: {
      "error": _vm.$attrs.errors.rate_plan.amount
    },
    model: {
      value: (_vm.$attrs['rate-plan'].amount),
      callback: function($$v) {
        _vm.$set(_vm.$attrs['rate-plan'], "amount", $$v)
      },
      expression: "$attrs['rate-plan'].amount"
    }
  }), _vm._v(" "), (false) ? _c('period-field', {
    attrs: {
      "error": _vm.$attrs.errors.rate_plan.period
    },
    model: {
      value: (_vm.$attrs['rate-plan'].period),
      callback: function($$v) {
        _vm.$set(_vm.$attrs['rate-plan'], "period", $$v)
      },
      expression: "$attrs['rate-plan'].period"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.submitLabel
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2052dd94","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/rate_plan/RatePlanBlankForm.vue
// module id = 597
// module chunks = 0